import { gql } from "@apollo/client";

export const CLIP_SAVE_MUTATION = gql`
  mutation ClipSave($input: ClipSaveInput!) {
    clipSave(input: $input) {
      success
      savedCount
      limit
      errors {
        message
      }
    }
  }
`;

export const CLIP_UNSAVE_MUTATION = gql`
  mutation ClipUnsave($input: ClipUnsaveInput!) {
    clipUnsave(input: $input) {
      success
      savedCount
      limit
      errors {
        message
      }
    }
  }
`;
